import { useState } from "react"
import { Card } from "@components/anti/Card"
import { Image } from "@components/anti/Image"
import Link from "@components/anti/Link"
import { translations } from "src/helper/translations"
import { useScrollAnim } from "src/hooks/hooks"
import {
  convertHtmlToReact,
  convertJson,
  extractMeta,
  imgUrl,
} from "src/mixins"
import NewsroomMediaGallery from "./newsroom-media-gallery"

function NewsroomMediaKit({ data, locale }) {
  const [trigger, anim] = useScrollAnim()
  const [trigger2, anim2] = useScrollAnim()
  const [state, setState] = useState({
    openGallery: false,
    galleryItem: null,
  })
  const factsheet = extractMeta(data?.page?.meta, "factsheet")
  return (
    <div className="newsroom-media-kit" id="newsroom-media-kit">
      <NewsroomMediaGallery
        isOpen={state.openGallery}
        galleryItem={state.galleryItem}
        onClose={() => {
          setState({
            openGallery: false,
            galleryItem: null,
          })
          const html = document.querySelector("html")
          const body = document.querySelector("body")
          body.classList.remove("no-scroll")
          html.classList.remove("no-scroll")
        }}
      />
      <div className="newsroom-media-kit__cover">
        <div className="newsroom-media-kit__cover-content container py-main">
          <div className="xxi-box">
            <Image
              src={imgUrl(factsheet?.logo_image)}
              className="img-xxi"
              alt="img-xxi"
              width={160}
              height={60}
            />
          </div>
          <div className="factsheet-logo" ref={trigger}>
            <h3 className={`factsheet-logo__title ${anim(1)}`}>
              {translations[`factsheet_logo_${locale}`]}
            </h3>
            {convertJson(factsheet?.items)?.map((item, i) => (
              <Link href={item.download_url} key={`factsheet-logo__item-${i}`}>
                <h5 className={`factsheet-logo__item ${anim(2 + i)}`}>
                  {item[`title_${locale}`]} <i className="cxi-download" />
                </h5>
              </Link>
            ))}
            <small className={anim(3)}>{factsheet?.last_update}</small>
          </div>
        </div>
      </div>
      <div className="newsroom-media-kit__photos" ref={trigger2}>
        <div className="container py-main">
          <h3 className={`title ${anim2(1)}`}>
            {translations[`brand_images_${locale}`]}
          </h3>
          <p className={`disclaimer mb-4 ${anim2(2, "fadeInUp8")}`}>
            {convertHtmlToReact(factsheet[`disclaimer_${locale}`])}
          </p>
          <div className="row">
            {data?.gallery?.data?.map((item, i) => (
              <div
                className={`col-md-4 newsroom-media-kit__photos-item ${anim2(
                  i + 3
                )}`}
                key={`newsroom-media-kit__photos-item-${i}`}
                onClick={() => {
                  setState({
                    openGallery: true,
                    galleryItem: {
                      ...extractMeta(item.meta, "galley"),
                      title: item[`title_${locale}`],
                    },
                  })
                  const html = document.querySelector("html")
                  const body = document.querySelector("body")
                  body.classList.add("no-scroll")
                  html.classList.add("no-scroll")
                }}
                role="presentation"
              >
                <Card
                  className="newsroom-media-kit__photos-item"
                  title={item[`title_${locale}`]}
                  img={imgUrl(
                    convertJson(extractMeta(item.meta, "galley")?.items)[0]
                      ?.image
                  )}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewsroomMediaKit
